import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';

export const YoutubeEmbed = ({url, title}) => {
  const videoId = parseYouTubeLink(url);

  if (!videoId) return null;

  return (
    <div className='w-full aspect-video'>
      <LiteYouTubeEmbed
        id={videoId}
        title={title}
        adNetwork={false}
        noCookie={true}
        params='autoplay=1&muted=1'
      />
    </div>
  );
};

const parseYouTubeLink = (url) => {
  const urlObj = new URL(url);
  const videoId = urlObj.searchParams.get('v');
  return videoId;
};
